module.exports = __webpack_public_path__ + "img/cb1.a52f9b71.jpg";